export const batterySizes = [
  { refNo: 16020, name: '1C' },
  { refNo: 16200, name: '1C' },
  { refNo: 16201, name: '1C-hp' },
  { refNo: 16205, name: '1D' },
  { refNo: 16206, name: '1D-hp' },
  { refNo: 16210, name: '2D' },
  { refNo: 16211, name: '2D-hp' },
  { refNo: 16215, name: '3D' },
  { refNo: 16220, name: '4D' },
  { refNo: 16225, name: '5D' },
  { refNo: 16235, name: '7D' },
];
